import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react';
import { useStore } from '../../../stores/Store';
import ViewProfessionalPage from './viewProfessional';
import './style.scss';
import { TextInput, TextInputDropdown, OutlinedButton, ProfessionalCard } from '../../../components';
import { MenuItem } from '@mui/material';
import { formatCash, processProjectsData, processProfessionalsData } from '../../../utils/sharedFunctions';
import { User } from '../../../services/requests';
const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const AddIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/AddIcon.svg`;
var mobile = require('is-mobile');

const EmailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

const Professionals = observer(() => {
    const store = useStore();
    const [, updateState] = useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);
    const [Professionals, setProfessionals] = useState([]);
    const [Leads, setLeads] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [AddPro, setAddPro] = useState(false);
    const [ViewProfessional, setViewProfessional] = useState(false);
    const [SelectedUser, setSelectedUser] = useState({});
    const [Page, setPage] = useState(0);
    const [FullName, setFullName] = useState([]);
    const [IsEdited, setisEdited] = useState(false)
    const [IsMenuOpen, setIsMenuOpen] = useState(false);
    const [NewUser, setNewUser] = useState({
        roles: [1988],
        accountType: "public",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        address: "",
        city: "",
        state: "",
        country: "",
        bio: "",
        imgUrl: "",
        website: "",
        linkedin: "",
        instagram: "",
        twitter: "",
        facebook: "",
        companyName: null,
        companyRegistrationNumber: null,
        companyVatNumber: null,
        companyRole: null,
        businessType: null,
        companyWebsite: null,
        companyAddress: "",
        companyCity: "",
        companyState: "",
        companyCountry: "",
        companyIndustry: "",
        industry: "",
        positionInCompany: "",
        servicesAs: "",
        experienceLevel: '',
        vatNumber: "",
        accountUsage: "",
        notifications: [],
        professional: {
            gender: 'Prefer Not To Say',
            languages: '',
            ratePerDay: '',
            ratePerHour: '',
            services: ''
        },
        password: "",
        verified: false,
        blocked: false,
        webauthn: "",
        Authenticators: []
    });
    useEffect(() => {
        fetchData();
    }, [IsEdited]);
    const fetchData = async () => {
        store.setLoading(true);
        try {
            let [Users, Briefs, projects, projectPlans, evaluation, quotes] = await Promise.all([
                store.getUsers(),
                store.getBriefs(),
                store.getProjects(),
                store.getProjectPlans(),
                store.getEvaluation(),
                store.getQuote()
            ]);
            projects = Array.isArray(projects)
                ? projects.filter(item => item.projectPlan)
                : [];

            Users = Array.isArray(Users) ? Users : [];

            if (Array.isArray(evaluation) && evaluation.length > 0 && projects.length > 0) {
                projects = projects.filter(project =>
                    project.evaluation &&
                    (project.brief || project.briefId) &&
                    project.client
                ).map(project => {
                    project.evaluation = typeof project.evaluation === 'string'
                        ? evaluation.find(e => e._id === project.evaluation)
                        : project.evaluation;

                    project.brief = project.brief
                        ? Briefs.find(brief => brief._id === project.brief)
                        : Briefs.find(brief => brief._id === project.briefId);

                    project.client = typeof project.client === 'string'
                        ? Users.find(user => user._id === project.client)
                        : project.client;

                    return project;
                }).filter(project => project.evaluation && project.brief);
            } else {
                projects = [];
                evaluation = [];
            };

            const pros = Users.filter(item => item.roles[0] === 1988);
            const clients = Users.filter(item => item.roles[0] === 1989);
            const leads = Users.filter(item => item.roles[0] === 1987);
            let validBriefs = Briefs.filter(item => item.projectPlan && item.projectPlan.length > 0);
            let validProjects = projects.filter(item => item.projectPlan && Object.keys(item.projectPlan).length > 0);

            const projectPlanMap = new Map(projectPlans.map(plan => [plan._id, plan]));
            const projectMap = new Map(projects.map(project => [project.brief?._id, project]));

            validBriefs.forEach(job => {
                const projectPlanId = job.projectPlan[0];
                job.projectPlan[0] = projectPlanMap.get(projectPlanId) || job.projectPlan[0];

                const project = projectMap.get(job._id);
                if (project) {
                    job.evaluation = project.evaluation;
                    job.project = project;
                }
            });

            validProjects.forEach(project => {
                const projectPlanId = project.projectPlan[0];
                project.projectPlan = projectPlanMap.get(projectPlanId) || project.projectPlan;
            });

            const professionals = processProfessionalsData(pros, validProjects, validBriefs, projects);
            const defaultUser = { firstName: 'Not Assigned', lastName: '' };
            validBriefs.forEach(job => {
                job.talentPartner = mapEntity(job.talentPartner, leads, defaultUser);
                job.client = mapEntity(job.client, clients, defaultUser);

                const professional = mapEntity(job.projectPlan[0]?.professional, professionals, null);
                if (professional) {
                    job.projectPlan[0].professional = professional;
                }

                if (Array.isArray(job.quote) && job.quote.length > 0) {
                    job.quote[0] = typeof job.quote[0] === 'string'
                        ? mapEntity(job.quote[0], quotes, null)
                        : job.quote[0];
                } else {
                    job.quote = [];
                }
            });

            validBriefs = validBriefs.filter(brief => brief.projectPlan[0]?.professional);

            validProjects.forEach(project => {
                project.fulfillmentLead = mapEntity(project.fullfilmentLead, leads, defaultUser);
                project.client = mapEntity(project.client, clients, defaultUser);

                const professional = mapEntity(project.projectPlan?.professional, professionals, null);
                if (professional) {
                    project.projectPlan.professional = professional;
                }
            });

            setLeads(leads);
            setProfessionals(professionals);
            forceUpdate();
        } catch (error) {
            console.log(error);
        } finally {
            store.setLoading(false);
        }
    };

    const mapEntity = (entity, collection, defaultValue) => {
        const foundEntity = collection.find(item => item._id === entity);
        return foundEntity || defaultValue;
    };



    const handleOpenAddProfessional = () => {
        setAddPro(true);
        forceUpdate();
    };
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        forceUpdate();
    };
    const filteredPros = Professionals.filter(pro => {
        if (!searchTerm) return true;
        const searchValue = String(searchTerm).toLowerCase();
        return (String(`${pro.firstName} ${pro.lastName}`).toLowerCase().includes(searchValue) || (pro.email && pro.email.toLowerCase().includes(searchValue)));
    });
    const handleViewUser = (id) => {
        let pros = [...Professionals];
        let selectedPro = pros.find(pro => pro._id === id);
        setSelectedUser(selectedPro);
        setViewProfessional(true);
    };
    const handleUserDetailChange = (e) => {
        let user = NewUser;

        if (e.currentTarget.id === 'Name') {
            let fullName = e.target.value;
            user.firstName = fullName.split(' ')[0];
            user.lastName = fullName.split(' ')[1];
            setFullName(fullName)
        }
        if (e.currentTarget.id === 'ContactNumber') {
            const value = e.target.value;
            if (/[^0-9]/.test(value)) {
                return;
            }
            user.phone = value;
        }
        if (e.currentTarget.id === 'Email') {
            user.email = e.target.value;
        }
        if (e.currentTarget.id === 'lang') {
            user.professional.languages = e.target.value;
        }
        if (e.currentTarget.id === 'dailyRate') {
            user.professional.ratePerDay = e.target.value;
        }
        if (e.currentTarget.id === 'location') {
            user.location = e.target.value;
        }
        if (e.currentTarget.id === 'industry') {
            user.industry = e.target.value;
        }
        setNewUser(user);
        forceUpdate();
    };
    const handleSaveUser = async () => {
        store.setLoading(true);
        try {
            let user = NewUser;
            let regexPass = EmailRegex.test(user.email);
            if (!regexPass) {
                store.setLoading(false);
                return;
            }
            let result = await store.createUser(user);
            if (!result) {
                alert('Error saving user');
                return;
            }
            fetchData();
            setAddPro(false);
            forceUpdate();
        } catch (e) {
            console.log(e)
        }
    };
    const handleRoleChange = (e) => {
        let user = NewUser;
        user.professional.services = e.target.value;
        setNewUser(user);
        forceUpdate();
    };
    const handleGenderChange = (e) => {
        let user = NewUser;
        user.gender = e.target.value;
        setNewUser(user);
        forceUpdate();
    };
    const handleEXPChange = (e) => {
        let user = NewUser;
        user.experienceLevel = e.target.value;
        setNewUser(user);
        forceUpdate();
    };
    const backClicked = (back, isEdited) => {
        if (isEdited) {
            fetchData();
            setisEdited(isEdited)
        };
        setViewProfessional(back);
        forceUpdate();
    };
    const handleCloseAddUser = () => {
        setAddPro(false);
    };
    function toogleNext_back(e) {
        let page = Page;
        if (e.target.id === 'next') {
            page += 1;
        } else {
            page -= 1;
        }
        setPage(page);
    };
    const openMenu = () => {
        setIsMenuOpen(true);
    };
    const closeMenu = () => {
        setIsMenuOpen(false);
    };
    if (mobile()) {
        return (
            <div>

            </div>
        );

    } else {
        return (
            <div className='ProfessionalPage'>
                <div className='ProfessionalPageHeader'>
                    <p>Professionals</p>
                    <img src={Credipple} alt='Credipple Logo' />
                </div>
                <div className='ProfessionalPageBody'>
                    {(ViewProfessional) ?
                            <ViewProfessionalPage backClick={(e, isEdited) => { backClicked(e, isEdited) }} selectedPro={SelectedUser} leads={Leads} pros={Professionals} />
                       
                        :
                        <>
                            <div className='filterAndSearch'>
                                <div className='proListSection'>
                                    <p >Professional List</p>
                                    {store.user.permissions.includes("Client_Create") ? (<div className='openAddpro' onMouseEnter={openMenu} onMouseLeave={closeMenu}>...
                                        {(IsMenuOpen) ?
                                            <div className='proMenuOpen'>
                                                <div className='AddproConatiner'>
                                                    <img src={AddIcon} alt='Add Client' onClick={handleOpenAddProfessional} />
                                                    <p onClick={handleOpenAddProfessional}>Add Professional</p>
                                                </div>
                                                <hr />
                                            </div> : null}
                                    </div>) : null}
                                </div>
                                <div className='numofItems'>
                                    <p className='spancular'>{filteredPros.length}</p>
                                </div>
                                <div className='filterSearchSect'>
                                    <div className='search-bar-section' style={{ width: '95%', backgroundColor: '#fff' }}>
                                        <img src={SearchIcon} alt='Search Icon' />
                                        <input style={{ color: '#6D4194' }} placeholder='Search' onChange={handleSearchChange}></input>
                                    </div>
                                </div>
                            </div>
                            <div className='professionalsList'>
                                {
                                    filteredPros.map((item, index) => {
                                        return (
                                            <ProfessionalCard handleViewUser={handleViewUser} item={item} />
                                        );
                                    })}
                            </div>
                        </>
                    }
                </div>

                {/* ADD PRO SECTION */}
                {(AddPro) ?
                    <div className='dashPopUp' style={{ zIndex: '11' }}>
                        <div className='addUserHeaderSection'>
                            <p>Create Professional</p>
                        </div>
                        {Page === 0 ? <>
                            <div className='addUserBodySection'>
                                <div className='topInputs'>
                                    <TextInput className='userInfoFields' placeholder='Name & Surname' value={FullName} label='Name & Surname' id='Name' onChange={handleUserDetailChange}></TextInput>
                                    <TextInput className='userInfoFields' placeholder='Contact Number' value={NewUser.phone} label='Contact Number' id='ContactNumber' onChange={handleUserDetailChange}></TextInput>
                                </div>
                                <div className='topInputs'>
                                    <TextInput className='userInfoFields' placeholder='Email' value={NewUser.email} label='Email' id='Email' onChange={handleUserDetailChange}></TextInput>
                                    <TextInputDropdown className='userInfoFields' placeholder='Role' label='Role' id='Role' value={NewUser.professional.services} onChange={handleRoleChange}>
                                        <MenuItem value='Design and Illustration'>Design and Illustration</MenuItem>
                                        <MenuItem value='Digital Marketing and Social Media'>Digital Marketing and Social Media</MenuItem>
                                        <MenuItem value='Mobile and Web Development'>Mobile and Web Development</MenuItem>
                                        <MenuItem value='Photography and Videography'>Photography and Videography</MenuItem>
                                        <MenuItem value='Writing and Reporting'>Writing and Reporting</MenuItem>
                                    </TextInputDropdown>
                                </div>
                                <div className='topInputs'>
                                    <TextInputDropdown className='userInfoFields' placeholder='Gender' value={NewUser.professional.gender} label='Gender' id='gender' onChange={handleGenderChange}>
                                        <MenuItem value='Male'>Male</MenuItem>
                                        <MenuItem value='Female'>Female</MenuItem>
                                        <MenuItem value='Prefer Not To Say'>Prefer Not To Say</MenuItem>
                                    </TextInputDropdown>
                                    <TextInput className='userInfoFields' placeholder='Location' label='Location' id='location' value={NewUser.location} onChange={handleUserDetailChange}></TextInput>
                                </div>
                            </div>
                        </> :
                            <div className='addUserBodySection'>
                                <div className='topInputs'>
                                    <TextInput className='userInfoFields' placeholder='0,00' label='Daily Rate' id='dailyRate' value={NewUser.professional.ratePerDay} onChange={handleUserDetailChange}></TextInput>
                                    <TextInput className='userInfoFields' placeholder='Language' label='Language' id='lang' value={NewUser.professional.languages} onChange={handleUserDetailChange}></TextInput>
                                </div>
                                <div className='topInputs'>
                                    <TextInput className='userInfoFields' value={NewUser.industry} placeholder='Industry' label='Industry' id='industry' onChange={handleUserDetailChange}></TextInput>
                                    <TextInputDropdown className='userInfoFields' value={NewUser.experienceLevel} placeholder='Experience Level' label='Experience Level' id='exp' onChange={handleEXPChange}>
                                        <MenuItem value='Entry Level'>Entry Level</MenuItem>
                                        <MenuItem value='Junior'>Junior</MenuItem>
                                        <MenuItem value='Junior-Intermediate'>Junior-Intermediate</MenuItem>
                                        <MenuItem value='Intermediate'>Intermediate</MenuItem>
                                        <MenuItem value='Intermediate-Senior'>Intermediate-Senior</MenuItem>
                                        <MenuItem value='Senior'>Senior</MenuItem>
                                    </TextInputDropdown>
                                </div>
                            </div>
                        }
                        {Page === 0 ?
                            <div className='addUserActionSection'>
                                <OutlinedButton id='cancel' className='cancelButton' onClick={handleCloseAddUser}>Cancel</OutlinedButton>
                                <OutlinedButton id='next' className='saveButton' onClick={toogleNext_back}>Next</OutlinedButton>
                            </div>
                            :
                            <div className='addUserActionSection'>
                                <OutlinedButton id='back' className='cancelButton' onClick={toogleNext_back}>Back</OutlinedButton>
                                <OutlinedButton id='save' className='saveButton' onClick={handleSaveUser}>Save</OutlinedButton>
                            </div>
                        }
                    </div> :
                    null
                }
            </div>
        )
    }
})

export default Professionals;